import React from 'react';
import CompletionCertificate from '../completion-certificate';
import MyPicture from '../my-picture';
import MyName from '../my-name';
import WordsAndSpellingPrekto1 from '../words-and-spelling-prek-to-1';
import VocabularyPrekto1 from '../vocabulary-prek-to-1';
import SentencePrekto1 from '../sentence-prek-to-1';
import MyOpinionPrekTo1 from '../my-opinion-prek-to-1';
import WordCardsPreKto1 from '../word-cards-prek-to-1';
import NameLabels from '../name-labels';
import NameTracingPrekTo1 from '../name-tracing-prek-to-1';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

/** Key is sheetId */
const Map = {
  10: {
    name: 'myPicture',
    Component: props => <MyPicture {...props} noFooterText />
  },
  11: {
    name: 'myNameTitlecase',
    Component: props => <MyName {...props} isWide />
  },
  12: {
    name: 'words',
    Component: props => <WordsAndSpellingPrekto1 {...props} rows={2} cols={3} />
  },
  13: {
    name: 'spelling',
    Component: props => <WordsAndSpellingPrekto1 {...props} isSpelling rows={5} cols={1} />
  },
  14: {
    name: 'vocabulary',
    Component: props => <VocabularyPrekto1 {...props} />
  },
  15: {
    name: 'sentence',
    Component: props => <SentencePrekto1 {...props} />
  },
  16: {
    name: 'myOpinion',
    Component: props => <MyOpinionPrekTo1 {...props} />
  },
  17: {
    name: 'opinion',
    Component: props => <MyOpinionPrekTo1 reasons {...props} />
  },
  171: {
    name: 'Wall Cards',
    Component: props => <WordCardsPreKto1 {...props} />
  },
  172: {
    name: 'Word Tags',
    Component: props => <NameLabels {...props} isWide />
  },
  173: {
    name: 'Name Tags',
    Component: props => <NameTracingPrekTo1 {...props} isWide />
  },
  18: {
    name: 'certificationOfCompletionWhale',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'whale',
            width: 750,
            height: 200
          }
        ]}
        completedTitle={t('letterAndNumbers')}
        isWide
      />
    )
  },
  19: {
    name: 'certificationOfCompletionWhale',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'eagle',
            width: 500,
            height: 200
          }
        ]}
        completedTitle={t('kickStartKindergarten')}
        isWide
      />
    )
  }
};

export default Map;
